import service1 from "../../Images/services-1.png"
import service2 from "../../Images/services-2.png"
import service3 from "../../Images/services-3.png"
import service4 from "../../Images/services-4.png"
import service5 from "../../Images/services-5.png"
import service6 from "../../Images/services-6.png"
import service7 from "../../Images/services-7.png"
import service8 from "../../Images/services-8.png"
import service9 from "../../Images/services-9.png"
import arroewIcon from "../../Images/arrow-Icon.png"

export const ServiceData = [
    {
        id : 1,
        Name : "Massage Therapy",
        img : service1 ,
        para : "It is a long established fact that a reader and we arewill be distracted.",
        arrow : arroewIcon
    },
    {
        id : 2,
        Name : "Body Treatments",
        img : service2 ,
        para : "It is a long established fact that a reader and we arewill be distracted.",
        arrow : arroewIcon
    },
    {
        id : 3,
        Name : "Aroma Therapy",
        img : service3 ,
        para : "It is a long established fact that a reader and we arewill be distracted.",
        arrow : arroewIcon
    },
    {
        id : 4,
        Name : "Natural Relaxation",
        img : service4 ,
        para : "It is a long established fact that a reader and we arewill be distracted.",
        arrow : arroewIcon
    },
    {
        id : 5,
        Name : "Trendy Hair Style",
        img : service5 ,
        para : "It is a long established fact that a reader and we arewill be distracted.",
        arrow : arroewIcon
    },
    {
        id : 6,
        Name : "Facial Therapy",
        img : service6 ,
        para : "It is a long established fact that a reader and we arewill be distracted.",
        arrow : arroewIcon
    },
    {
        id : 7,
        Name : "Stone Therapy",
        img : service7 ,
        para : "It is a long established fact that a reader and we arewill be distracted.",
        arrow : arroewIcon
    },
    {
        id : 8,
        Name : "Hair Color",
        img : service8 ,
        para : "It is a long established fact that a reader and we arewill be distracted.",
        arrow : arroewIcon
    },
    {
        id : 9,
        Name : "Pedicure - Manicure",
        img : service9 ,
        para : "It is a long established fact that a reader and we arewill be distracted.",
        arrow : arroewIcon
    },
]